import { createFileRoute } from "@tanstack/react-router";
import { McpAssistantPage } from "@/components/mcp-chat/McpAssistantPage";

export const Route = createFileRoute("/dashboard/chat")({
	component: DashboardChatRoute,
	head: () => ({
		meta: [
			{ title: "Chat, AgentFramer" },
			{
				name: "description",
				content:
					"Chat with the AgentFramer MCP directly from the dashboard to generate media, inspect history, and manage workspace actions.",
			},
		],
	}),
});

function DashboardChatRoute() {
	return <McpAssistantPage />;
}
